
import { CatalogModel } from './catalog';
import { ShareholderPersonDocumentModel } from './shareholderPersonDocument';


export class BeneficiaryPersonModel {
    document: ShareholderPersonDocumentModel;
    gender: CatalogModel;
    firstName?: string;
    secondName?: string;
    lastName?: string;
    secondLastName?: string;
    businessName?: string;
    percentageParticipation?: number;
    typePerson: string;
    constructor() {
        this.document = new ShareholderPersonDocumentModel();
        this.typePerson = 'N';
    }
}
